import React, { useState } from 'react';
import RightArrow from '../../../../components/Icons/icons/RightArrow';
import ButtonComponent from '../../../../components/common-components/ButtonComponent/ButtonComponent';
import IconContainer from '../../../../components/common-components/FtuxComponent/IconContainer';
import ModalComponent from '../../../../components/common-components/ModalComponent/ModalComponent';
import { NotificationManager } from 'react-notifications';
import { disablePreservationPlan } from '../../../../services/payment.service';

const UserOnPreservationPlanModal = ({ show, handleCancel }) => {
  const [showLoading, setShowLoading] = useState(false);

  const handleRestoreAccess = async () => {
    setShowLoading(true);
    try {
      const response = await disablePreservationPlan();
      if (response.status) {
        NotificationManager.success('Preservation Plan Disabled', '', 3500);
        window.location.reload();
      }
    } catch (error) {
      NotificationManager.error(error.message, '', 3500);
    }
    setShowLoading(false);
  };

  return (
    <ModalComponent
      show={show}
      width={500}
      outsideClickClose={false}
      style={{ padding: '32px' }}
      bodyStyle={{ padding: 0 }}>
      <div className="warning-modal modal-main-content">
        <IconContainer icon="🔒" bgColor="#FEFCE8" />
        <h2 style={{ marginBottom: 16 }}>On Preservation Plan</h2>
        <p style={{ paddingBottom: '24px' }}>
          You’ve enabled the preservation plan. All your influencer data, emails, CRM, performance is being stored.{' '}
        </p>
        <p style={{ paddingBottom: '24px' }}>
          Your creators will still have access to their dashboard & the links will work too.
        </p>

        <ButtonComponent
          onClick={handleRestoreAccess}
          style={{
            padding: '10px 18px',
            width: '100%',
            marginBottom: '16px',
            border: '1px solid var(--border-highlight)',
          }}
          showLoading={showLoading}
          rightIcon={<RightArrow color="white" />}>
          Restore my access
        </ButtonComponent>
        <ButtonComponent onClick={handleCancel} variant="secondary" style={{ padding: '10px 18px', width: '100%' }}>
          Close
        </ButtonComponent>
      </div>
    </ModalComponent>
  );
};

export default UserOnPreservationPlanModal;
